import { Box, Checkbox, IconButton, Typography } from "@mui/material";
import LayersIcon from "@mui/icons-material/Layers";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import FitScreenIcon from "@mui/icons-material/FitScreen";
import { useDataReview } from "../../contexts/DataReviewContext";
import { useMap } from "../../contexts/MapContext";
import { Layer } from "../../types/layer";
import { bboxOfGeometry } from "../dataReview/geometry";
import { LINE, MUTED, TEAL, floatSx } from "./editorTheme";
import { useEditorData } from "./useEditorData";
import { useVegEditor } from "./VegEditorContext";

/** Bottom-right of the map: which layers show, zoom, fit to the area. */
export default function VegEditorMapFab({ vegetationLayer }: { vegetationLayer: Layer | null }) {
  const { map } = useMap();
  const d = useEditorData();
  const { layersOpen, setLayersOpen } = useVegEditor();
  const { showImagery, setShowImagery, showChanges, setShowChanges } = useDataReview();
  const fit = () => {
    const g = d.jobArea?.geometry ?? d.boundary?.geometry;
    const b = g && bboxOfGeometry(g);
    if (map && b) map.fitBounds(b, { padding: 80, duration: 500 });
  };
  const ib = { width: 32, height: 32, borderRadius: 1.5, color: "rgba(255,255,255,0.85)", "&:hover": { bgcolor: "rgba(255,255,255,0.1)" } };
  const row = (label: string, on: boolean, set: (v: boolean) => void) => (
    <Box component="label" sx={{ display: "flex", alignItems: "center", gap: 0.75, cursor: "pointer" }}>
      <Checkbox size="small" checked={on} onChange={(ev) => set(ev.target.checked)} sx={{ p: 0, color: MUTED, "&.Mui-checked": { color: TEAL } }} />
      <Typography sx={{ fontSize: 13 }}>{label}</Typography>
    </Box>
  );
  return (
    <Box sx={{ ...floatSx, position: "fixed", right: 12, bottom: 12, display: "flex", flexDirection: "column", p: 0.4, zIndex: 1095 }}>
      {layersOpen && (
        <Box sx={{ ...floatSx, position: "absolute", right: 46, bottom: 0, width: 220, p: 1.5, display: "flex", flexDirection: "column", gap: 1.25 }}>
          {vegetationLayer && row("Vegetation layer", !!vegetationLayer.active, () => vegetationLayer.toolbarButton?.props?.onClick?.())}
          {row("Aerial photo", showImagery, setShowImagery)}
          {row("Detected shapes", showChanges, setShowChanges)}
        </Box>
      )}
      <IconButton onClick={() => setLayersOpen(!layersOpen)} aria-label="Layers" title="Layers" sx={ib}><LayersIcon sx={{ fontSize: 17 }} /></IconButton>
      <Box sx={{ height: 1, bgcolor: LINE, mx: 0.5, my: 0.25 }} />
      <IconButton onClick={() => map?.zoomIn()} aria-label="Zoom in" sx={ib}><AddIcon sx={{ fontSize: 17 }} /></IconButton>
      <IconButton onClick={() => map?.zoomOut()} aria-label="Zoom out" sx={ib}><RemoveIcon sx={{ fontSize: 17 }} /></IconButton>
      <IconButton onClick={fit} aria-label="Fit to area" title="Fit to area" sx={ib}><FitScreenIcon sx={{ fontSize: 17 }} /></IconButton>
    </Box>
  );
}
